import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default (props) => {
    return _jsx("span", { className: "material-symbols-outlined align-middle", style: props.size === 'inherit' ? { 'fontSize': 'inherit', 'lineHeight': 'inherit' } : {}, children: props.children });
};
